var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.258 2.727-1.485-1.485A2.555 2.555 0 0 0 17.016.5c-.625 0-1.29.273-1.758.742l-13.79 13.79L1 19.483a.894.894 0 0 0 .898 1.016h.118l4.453-.469L20.258 6.242a2.476 2.476 0 0 0 0-3.515ZM5.922 18.82l-3.633.39.39-3.632L12.993 5.266l3.242 3.242L5.922 18.82ZM19.359 5.383l-2.265 2.265-3.242-3.242 2.265-2.265c.235-.235.547-.391.899-.391.351 0 .664.156.898.39l1.445 1.446a1.25 1.25 0 0 1 0 1.797Z",
    fill: "#9496AC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.c5cf7a0464c2d17ec7766a3c236b466d.svg";